import { VerifyInterface } from '../../../app/models/tabverify';
import { v4 as uuid } from 'uuid';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import { toast } from 'react-toastify';
import agent from './../../../app/api/agent';
import { LocalUploadInterface } from '../../../app/models/Profile';
import { store } from '../../../app/stores/store';
import { User } from '../../../app/models/user';

function VerifySaveFunction(
  subChildObj: VerifyInterface[],
  response: any,
  sectionsResonse?: any,
  print?: string,
  usersList?: User[],
) {
  const items: any[] = [];
  const FilmArray: string[] = response.map((r: { title: any }) => r.title);
  const lastItem = subChildObj[subChildObj.length - 1];

  // Wrap the lastItem in an array
  const lastItemArray = sectionsResonse ? [lastItem] : subChildObj;
  lastItemArray?.forEach(async (x: any) => {
    let num = x.number_of_elem === '' ? '1' : x.number_of_elem;
    const numberOfElemToInt = parseInt(num);
    for (let i = 1; i <= numberOfElemToInt; i++) {
      const FimTitle =
        (store?.dashboardStore?.dashboard?.checkClikedWorkLevel.title ||
          sectionsResonse.title ||
          '') +
        ' - ' +
        store.dashboardStore.dashboard.dashboardWorkLevelMaster.title +
        ' - ' +
        x.childPane.split('/')[2];
      let IncFilmName = (FimTitle || '')?.includes('~')
        ? FimTitle
        : FimTitle + '~1'; // Checking the film title already exist or not
      const toCheck = (name: string) => {
        // Recursion Function to append name
        if (FilmArray?.includes(name)) {
          let incVal = name?.split('~')[1]; //"11"
          const toint = parseInt(incVal) + 1; //12
          incVal = toint?.toString(); //"12"
          IncFilmName = IncFilmName?.split('~')[0] + '~' + incVal; //test+"12" - "test12"
          toCheck(IncFilmName); //calling recursion again
          return IncFilmName;
        }
        FilmArray.push(IncFilmName);
        return IncFilmName;
      };
      toCheck(IncFilmName); // Recursion Function to append name
      let result = x.photos.concat(
        x.files.filter((bo: any) =>
          x.photos.every((ao: any) => ao.id !== bo.id),
        ),
      );
      result = result.map((r: any) => {
        return {
          ...r,
          fileId: uuid(),
        };
      });
      const generatedID = uuid();

      const createAssignedUsersArray = function () {
        return usersList?.map((usr: User) => ({
          appUserId: usr.id,
          itemLevelId: generatedID,
          isHost: true,
        }));
      };

      const createCurrentUsers = function () {
        return usersList?.map((usr: User) => usr.displayName).join(', ');
      };

      const metaDataClone = JSON.parse(JSON.stringify(x.metadata));
      // eslint-disable-next-line
      metaDataClone?.forEach((_data: any, index: number) => {
        if (metaDataClone?.[index]) {
          metaDataClone[index][`elementId`] = uuid();
          metaDataClone[index][`elementDateTime`] =
            store?.activityStore?.updateDateTime();
          metaDataClone[index].options.forEach(
            (_metadataOptions: any, i: number) => {
              if (metaDataClone[index].options[i])
                metaDataClone[index].options[i]['optionId'] = uuid();
            },
          );
        }
      });
      //element type is allowed to have / in its name for NFAI. So split in this way to get the name
      let splitArray = x.childPane.split('/');
      delete splitArray[0];
      delete splitArray[1];
      delete splitArray[splitArray.length - 1];
      splitArray = splitArray.filter((d: any) => d !== null);

      const newAssignedUsers = createAssignedUsersArray();
      const getCurrentUsers = createCurrentUsers();

      let item = {
        ...x,
        id: generatedID,
        type: x.parentPane,
        element: splitArray.join('/'),
        elementtypeid: x.childPane.split('/')[0],
        year: store.dashboardStore.dashboard.dashboardWorkLevelMaster.year,
        originIndia:
          store.dashboardStore.dashboard.dashboardWorkLevelMaster.originIndia,
        title: IncFilmName,
        language:
          store.dashboardStore.dashboard.dashboardWorkLevelMaster.language,
        number_of_element: x.number_of_elem,
        asset_tracking_status: 'New Asset Added',
        order_tracking: 'Received',
        files: result,
        physical_sensor_barcode: generatedID,
        physical_sensor_RFID: generatedID,
        physical_sensor_qrcode: generatedID,
        receivingdate: new Date().toISOString(),
        itemCreatedAt: new Date().toISOString(),
        last_modified: new Date().toISOString(),
        movementdate: new Date().toISOString(),
        maintenance: new Date().toISOString(),
        status_Time: new Date().toISOString(),
        assignedUsers: store.commonStore.hfcCustomerChanges
          ? newAssignedUsers
          : [
              {
                appUserId: store.userStore.user?.id,
                itemLevelId: generatedID,
                isHost: true,
              },
            ],
        itemHistory: [],
        certification_date:
          x.certification_date === null || x.certification_date === ''
            ? new Date().toISOString()
            : x.certification_date,
        year_reference:
          x.year_reference === null || x.year_reference === ''
            ? new Date().toISOString()
            : x.year_reference,
        metadata: metaDataClone,
        typeid: x.typeid,
        isReceiving: false,
        isReceivingOrder: false,
        isDeleted: false,
        current_user: store.commonStore.hfcCustomerChanges
          ? getCurrentUsers
          : store.userStore.user?.displayName!,
        current_task: 'Yet To Start',
        current_subtask: 'Yet To Start',
        itemCreatedBy: store.userStore.user?.customerName,
        registerId: store.dashboardStore.dashboard.checkClikedWorkLevel.id,
      };
      items.push(item);
      // store.activityStore.setActivityAllWithoutReload(item);
      store.dashboardStore.dashboard.updateLocalFileAPI?.forEach(
        (f: LocalUploadInterface) => {
          setTimeout(() => {
            agent.Files.updateLocalFileUpload(
              f.item,
              generatedID,
              encodeURI(f.path),
            );
          }, 700);
        },
      );
    }
  });

  //collect generated ids
  const itemIds = items.map((i) => i.id);

  // -------------------------------------->Posting All Items  Starts
  if (store.WorkLevelStore.selectedworkLevel !== undefined) {
    const data: any = {
      ...store.dashboardStore.dashboard.dashboardWorkLevelMaster,
      items,
    };
    const p = new Promise(async (resolve) => {
      await store.activityStore.updateItemLevel(data, sectionsResonse);
      await store.activityStore.loadActivity(items[0].id);
      resolve('');
    });
    p.then(() => {
      setTimeout(async () => {
        store.activityStore.selectedActivity = items[0];
        if (store.commonStore.hfcCustomerChanges && print && print !== '') {
          await agent.HFC.savePrintForEachItem(
            {
              print,
            },
            itemIds,
          );
        }
      }, 300);
    });
  }
  // -------------------------------------> Posting All Items  Ends
  sendRespectiveEmail(
    'Notification',
    items[0].title,
    sectionsResonse ? 'Item Created' : 'Created New Acquisition Verify Record',
    sectionsResonse ? 'Items' : 'FromVerify',
    `${items[0].type} is ${
      sectionsResonse ? 'Item Created' : 'verified'
    }successfully on`,
  ); //email Function
  setTimeout(() => {
    if (sectionsResonse) return;
    store.activityStore.loadCRPagination(
      store.dashboardStore.dashboard.setCRTablePageNumber,
    );
    store.dashboardStore.createOrderCount();
  }, 1000);
  if (store.receivingdeliveryStore.selectedReceivingDelivery) {
    const newArr = {
      ...store.receivingdeliveryStore.selectedReceivingDelivery,
      verify_Status: 'Verified',
    };
    if (!sectionsResonse)
      store.receivingdeliveryStore.updateReceivingDelivery(
        newArr,
        'FromVerify',
      );
  }

  //  toast.success('Package Record  updated succesfully');
  toast.success(
    `${sectionsResonse ? 'Item Cretated' : 'WorkLevel  Updated'} Succesfully.`,
  );
  !store.commonStore.hfcCustomerChanges &&
    store.userStore.user?.customerName !== 'Restoration' &&
    store.userStore.user?.customerName !== 'NFAI' &&
    window.location.hostname !== 'localhost' &&
    toast.info('Email sent successfully.');
  new Promise(() => {
    store.dashboardStore.dashboard.inventoryCount += items.length || 1;
    store.dashboardStore.dashboard.inventoryCount2 += items.length || 1;
  });

  store.dashboardStore.dashboard.onFirstLoadNoTransition = false;
  //  fade out
  store.dashboardStore.dashboard.setfadeIn = false;
  // setvalues automatically
  if (
    store.userStore.user?.customerName === 'Area 51' ||
    store.userStore.user?.customerName === 'Restoration'
  ) {
    store.dashboardStore.dashboard.valueForL3Inventory =
      'Create Order Receiving';
  } else {
    store.dashboardStore.dashboard.valueForL3Inventory = 'Tag';
  }
  store.dashboardStore.dashboard.isFilmFestival = false;
  setTimeout(() => {
    // set this inside function in dashboard store
    store.dashboardStore.dashboard.setfadeIn = true;
  }, 3000);

  store.dashboardStore.setRegisterUrlResponse([]);
  store.dashboardStore.setVerifyUrlResponse([]);
  store.dashboardStore.setcamImageBase64([]);
  store.dashboardStore.dashboard.updateLocalFileAPI = [];
  store.dashboardStore.showClickedValueForReceiving('', '', '');
  // ----------------------------->///to post the ids in Metadata report Headers
  setTimeout(async () => {
    if (sectionsResonse) return;
    await agent.Reports.metaDataIDItemVerify(itemIds);
  }, 500);
}
export default VerifySaveFunction;
